var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompetitiveBenchmarking = function SvgCompetitiveBenchmarking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.996,
    height: 63.99
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "noun-brand-strategy-6848452 (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.673 12.079a1 1 0 0 1-.377-.076l-3.58-1.488a.981.981 0 0 1 .754-1.811l3.58 1.488a.986.986 0 0 1-.377 1.887",
    "data-name": "Path 44473"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.538 35.357a.987.987 0 0 1-.377-1.89l3.58-1.488a.981.981 0 0 1 .754 1.808l-3.58 1.488a1 1 0 0 1-.377.079Z",
    "data-name": "Path 44474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.903 34.28a1 1 0 0 1-.374-.075l-3.58-1.488a.981.981 0 1 1 .75-1.812l3.58 1.488a.985.985 0 0 1-.377 1.887Z",
    "data-name": "Path 44475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.88 11.002a.987.987 0 0 1-.377-1.89l3.58-1.488a.981.981 0 0 1 .754 1.811l-3.58 1.488a.9.9 0 0 1-.377.079",
    "data-name": "Path 44476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.732 23.016H.981a.982.982 0 0 1 0-1.963h7.751a.982.982 0 1 1 0 1.963",
    "data-name": "Path 44477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.015 21.851h-7.751a.982.982 0 0 1 0-1.963h7.751a.982.982 0 1 1 0 1.963",
    "data-name": "Path 44478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.702 49.612a2.883 2.883 0 0 0 0 5.765h20.592a2.883 2.883 0 0 0 0-5.765Z",
    "data-name": "Path 44479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.501 12.222h4.992v5.163h-4.992Z",
    "data-name": "Path 44480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.799 12.222h-3.341v6.145a.98.98 0 0 1-.982.982h-6.952a.98.98 0 0 1-.982-.982v-6.145h-3.345a2.294 2.294 0 0 0-2.292 2.292v14.1a2.294 2.294 0 0 0 2.292 2.292h15.6a2.294 2.294 0 0 0 2.292-2.292v-14.1a2.29 2.29 0 0 0-2.289-2.289Zm-1.406 15.9h-2.826a.982.982 0 0 1 0-1.963h2.826a.982.982 0 0 1 0 1.963",
    "data-name": "Path 44481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.998-.004a21.7 21.7 0 0 0-21.5 21.32 21.4 21.4 0 0 0 7.914 16.134 12.6 12.6 0 0 1 4.448 9.634v.565h18.281v-.565a12.6 12.6 0 0 1 4.441-9.629 21.4 21.4 0 0 0 7.914-16.134A21.7 21.7 0 0 0 35.998-.004m12.054 28.617a4.26 4.26 0 0 1-4.255 4.255h-15.6a4.26 4.26 0 0 1-4.255-4.255v-14.1a4.26 4.26 0 0 1 4.255-4.255h15.6a4.26 4.26 0 0 1 4.255 4.255Z",
    "data-name": "Path 44482"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.433 57.066a7.6 7.6 0 0 0 15.131 0Z",
    "data-name": "Path 44484"
  })))));
};
export default SvgCompetitiveBenchmarking;